import { render, staticRenderFns } from "./SingleWorker.vue?vue&type=template&id=68f0d2bb"
import script from "./SingleWorker.vue?vue&type=script&lang=js"
export * from "./SingleWorker.vue?vue&type=script&lang=js"
import style0 from "./SingleWorker.vue?vue&type=style&index=0&id=68f0d2bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports